export const initialData = {
  libraryContent: {
    price: 0,
  },
  subscriptionPlan: "",
};
